import { formatValue } from '../../../scripts/formatValue';
import { useAppRouter } from '../../../hooks/useAppRouter';
import styles from '../css/menu.module.css';

// ASSETS
const no_image_vector = require('../../../assets/marca-dagua-sofchef.png');



export const RenderCatalog = ({item, index, companyData, clientData}) => {
    const navigate = useAppRouter();
    
    return (
        <li key={index}>
            <div id={`${item.title}`}>

                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', gap: 15, marginTop: 40, marginBottom: 20}}>
                    <div style={{width: 10, height: 35, borderTopRightRadius: 3, borderBottomRightRadius: 3, backgroundColor: companyData.background_color}}></div>
                    <h1 className={styles.titleCategoriesProdList}>{item.title}</h1>
                </div>

                {item.products.length > 0 && item.products.map((prod, index) => {

                    // FORMAT PRICE VALUES ==========>
                    const price = formatValue(prod.price);

                    const promotionPrice = prod.promotion && prod.promotion_price ? formatValue(prod.promotion_price) : null;

                    // CONTROLS THE PRODUCTS WHO WILL NOT BE SHOW TO CLIENTS UNDER 18 YEARS
                    if ((companyData.restriction && prod.restricted && clientData && !clientData.older) || !prod.view) return;


                    return (
                        <li key={index}>
                            <button
                                className={styles.productComponent}
                                style={{ backgroundColor: prod.active == false || (prod.useStock == true && prod.stockQuantity == 0) ? '#999' : '#fff' }}
                                onClick={() => {
                                    // if (!companyData.status || !prod.active) {
                                    if (!prod.active) {
                                        return;
                                    }

                                    navigate(`product/${prod.id}`);
                                }}
                            >

                                <img className={styles.imgProductMenu} src={prod.image || no_image_vector} />

                                <div className={styles.productsTextArea}>
                                    <p className={styles.textProducts} id={styles.productName} wrap="hard">
                                        {prod.name}
                                    </p>

                                    {/* ITEM DESCRIPTION CAN BE A NULL VALUE */}
                                    {prod.description && (
                                        <p className={styles.textProducts} id={styles.productDescription} style={{ color: '#555' }}>
                                            {prod.description}
                                        </p>
                                    )}

                                    {prod.type == 'combo' ? (
                                        <p className={styles.textProducts} id={styles.productPrice}>Á partir de {price}</p>

                                    ) : (
                                        <>
                                            {prod.promotion == true && prod.promotion_date >= new Date().toISOString().slice(0,10) ? (
                                                <div className={styles.textProducts} id={styles.productPrice} style={{ display: 'flex', flexDirection: 'row' }}>
                                                    <p id={styles.oldPrice} style={{ color: 'red', textDecoration: 'line-through', marginRight: 10 }}>
                                                        {price}
                                                    </p>
                                                    
                                                    <p id={styles.newPrice} style={{ color: 'green' }}>
                                                        {promotionPrice}
                                                    </p>
                                                </div>

                                            ) : (
                                                <p className={styles.textProducts} id={styles.productPrice}>
                                                    {price}
                                                </p>
                                            )}
                                        </>
                                    )}
                                    
                                </div>
                            </button>
                        </li>
                    );
                    
                })}
            </div>
        </li>
    );
};